var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.title,"close-on-click-modal":true,"visible":_vm.visible},on:{"close":_vm.handleCloseDialog}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }